/* eslint-disable import/named */
import { actionCreator } from 'utils';
import * as JobTypes from '../types/jobTypes';

// L O A D   J O B S
export function loadJobs() {
    return {
        type: JobTypes.LOAD_JOBS,
    };
}

export function loadJobsRes(data) {
    return {
        type: actionCreator(JobTypes.LOAD_JOBS, 'res'),
        data,
    };
}

export function loadJobsErr() {
    return {
        type: actionCreator(JobTypes.LOAD_JOBS, 'err'),
    };
}
// L O A D   J O B S

// S E T   J O B   F I L T E R
export function setJobFilters(key, value) {
    return {
        type: JobTypes.SET_JOB_FILTERS,
        key,
        value,
    };
}

export function setjobPagination(key, pagination) {
    return {
        type: JobTypes.SET_JOB_PAGINATION,
        key,
        pagination,
    };
}

export function setJobSort(key, type) {
    return {
        type: JobTypes.SET_JOB_SORT,
        sort: {
            key,
            type,
        },
    };
}

export function resetJobFilters() {
    return {
        type: JobTypes.RESET_JOB_FILTERS,
    };
}
// S E T   J O B   F I L T E R S

// T O G G L E   F O R M   J O B
export function toggleJobStatus(data, load) {
    return {
        type: JobTypes.TOGGLE_JOB_STATUS,
        data,
        load,
    };
}
// T O G G L E   F O R M   J O B

// S E T   C H E C K E D   J O B
export function setCheckedJob(ids) {
    return {
        type: JobTypes.SET_CHECKED_JOB,
        ids,
    };
}
// S E T   C H E C K E D   J O B

// T O G G L E   J O B   S T E P S
export function toggleJobStep(id, status) {
    return {
        type: JobTypes.TOGGLE_JOB_STEPS,
        id,
        status,
    };
}

export function toggleJobStepRes() {
    return {
        type: actionCreator(JobTypes.TOGGLE_JOB_STEPS, 'res'),
    };
}

export function toggleJobStepErr() {
    return {
        type: actionCreator(JobTypes.TOGGLE_JOB_STEPS, 'err'),
    };
}
// T O G G L E   J O B   S T E P S

// B U L K   C H E C K E D   J O B
export function bulkCheckedJob(ids, bulk) {
    return {
        type: JobTypes.BULK_CHECKED_JOB,
        bulk,
        ids,
    };
}

export function bulkCheckedJobRes() {
    return {
        type: actionCreator(JobTypes.BULK_CHECKED_JOB, 'res'),
    };
}

export function bulkCheckedJobErr() {
    return {
        type: actionCreator(JobTypes.BULK_CHECKED_JOB, 'err'),
    };
}
// B U L K   C H E C K E D   J O B

// A D D   J O B   P A L L E T E
export function addJobPalette(data, from) {
    return {
        type: JobTypes.ADD_NEW_PALLETE_JOB,
        data,
        from,
    };
}

export function addJobPaletteRes(loading, success) {
    return {
        type: actionCreator(JobTypes.ADD_NEW_PALLETE_JOB, 'res'),
        loading,
        success,
    };
}

export function addJobPaletteErr(error) {
    return {
        type: actionCreator(JobTypes.ADD_NEW_PALLETE_JOB, 'err'),
        error,
    };
}
// A D D   J O B   P A L L E T E


// S E T  C A L C U L   Q U A N T I T Y
export function setCalculQuantity(number) {
    return {
        type: JobTypes.SET_CALCUL_QUANTITY,
        number,
    };
}
// S E T  C A L C U L   Q U A N T I T Y

// A D D   J O B   E R R O R
export function addJobError(data) {
    return {
        type: JobTypes.ADD_NEW_ERROR_JOB,
        data,
    };
}

export function addJobErrorRes(loading, success) {
    return {
        type: actionCreator(JobTypes.ADD_NEW_ERROR_JOB, 'res'),
        loading,
        success,
    };
}

export function addJobErrorErr(error) {
    return {
        type: actionCreator(JobTypes.ADD_NEW_ERROR_JOB, 'err'),
        error,
    };
}
// A D D   J O B   E R R O R

// R E P O R T   J O B   E R R O R
export function reportJobErrorPopup(data) {
    return {
        type: JobTypes.REPORT_JOB_ERROR_POPUP,
        data,
    };
}
// R E P O R T   J O B   E R R O R
